import { IRootState } from '../reducer'
import { prefix } from './actions'

export const isLoading = (state: IRootState) => state[prefix].loadingArray.length > 0

export const searchString = (state: IRootState) => state[prefix].searchString

export const searchResults = (state: IRootState) => state[prefix].searchResults.results
